import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import useOutsideClick from '../../hooks/useOutsideClick';
import { getContentById } from '../../redux/ContentRegistry/popover';
import usePopoverPositionUpdater from '../../hooks/usePopoverPositionUpdater';
import './Popover.scss';
import KeyboardBackspace from '../icons/KeyboardBackspace';
import Close from '../icons/Close';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';

// Single Popover Instance Component
const PopOverInstance = ({ popover, index }) => {
    const { isVisible, contentId, position, targetId, props } = popover;
    const { isBack, card, cardId, backPopover, pinned } = props;

    const dispatch = useDispatch();
    const popoverRef = useRef();
    const { handlePopoverClick } = useHandlePopoverClick();

    // Determine if pinned prop is true (default is false)
    const isPinned = pinned === true;

    // Only enable outside click if not pinned
    useOutsideClick(popoverRef, () => {
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    }, !isPinned);

    usePopoverPositionUpdater(targetId, popoverRef);

    if (!isVisible) {
        return null;
    }

    const content = getContentById(contentId, props);
    const isClosed = props.isClosed !== undefined ? props.isClosed : false;

    return (
        <div
            className="zoobbe-popover"
            style={{ top: position.top, left: position.left, zIndex: 9999 + index }}
            ref={popoverRef}
            id={contentId}
        >
            {
                isClosed && (
                    <div className="zoobbe-popover__header">
                        {
                            isBack && (
                                <button className="back-button"
                                    id={`popover-back-${backPopover}`}
                                    onClick={(e) => handlePopoverClick(e, backPopover, { ...props, isBack: false, isPopPositionChanged: false })}
                                >
                                    <KeyboardBackspace size={26} />
                                </button>
                            )
                        }
                        <button
                            className="zoobbe-popover__close-btn"
                            onClick={() => {
                                dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
                            }}
                        >
                            <Close color='#e3e3e3' size={18} />
                        </button>
                    </div>
                )
            }

            <div className="zoobbe-popover__content">
                {content}
            </div>
        </div>
    );
};

// Main PopOver Component - renders all popovers
const PopOver = () => {
    const popovers = useSelector((state) => state.popover.popovers);

    return (
        <>
            {popovers.map((popover, index) => (
                <PopOverInstance key={`${popover.contentId}-${popover.targetId}-${index}`} popover={popover} index={index} />
            ))}
        </>
    );
};

export default PopOver;
